import * as React from 'react';
import classnames from 'classnames';
import Portal from '../portal/Portal';
import Draggable from 'react-draggable'; // The default

export interface IModalProps {
    isOpen?: boolean;
    onClose?: (event) => void;
    className?: string;
}

const Modal: React.SFC<IModalProps> = (props) => {
    const { children, isOpen, onClose, className } = props;
    return (
        <Portal>
            <div
                className={classnames('modal fade', {
                    show: isOpen
                })}
                id="exampleModal"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden={!!isOpen}
                style={{
                    display: isOpen ? 'block' : 'none',
                    paddingRight: '15px'
                }}
            >
                <div
                    className={classnames('modal-dialog', {
                        [className]: !!className
                    })}
                    role="document"
                >
                    <div className="modal-content">{children}</div>
                </div>
            </div>
            <Backdrop isOpen={isOpen} />
        </Portal>
    );
};

const Backdrop: React.SFC<{ isOpen }> = (props) => {
    return (
        <div
            className={classnames('modal-backdrop fade', {
                show: props.isOpen
            })}
        ></div>
    );
};

export default Modal;
